// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDemoRentalAttributesCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_DEMO_RENTAL_ATTRIBUTES_CRITERIA,
    value
});

export const updateDemoRentalAccountsCriteria = selectedAccounts => ({
    selectedAccounts,
    type: actions.UPDATE_DEMO_RENTAL_ACCOUNTS_CRITERIA
});

export const updateBeginDate = beginDateRange => ({
    beginDateRange,
    type: actions.UPDATE_DEMO_RENTAL_BEGIN_DATE
});

export const updateEndDate = endDateRange => ({
    endDateRange,
    type: actions.UPDATE_DEMO_RENTAL_END_DATE
});

export const updateDemoRentalSelectAllAccountsCriteria = dealers => ({
    dealers,
    type: actions.UPDATE_DEMO_RENTAL_SELECT_ALL_ACCOUNTS_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/action-creators/criteria.js